<ish-content-slot
  [slot]="'app_sf_base_cm:slot.pagevariant.content.pagelet2-Slot'"
  [pagelet]="pagelet"
></ish-content-slot>
